import { 
  BookOpen, Code2, Cpu, Terminal, Activity, 
  ShieldCheck, Zap, Lock, Eye, Radiation
} from 'lucide-react';

export interface NavItem {
  name: string;
  path: string;
  icon: any;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export interface ProjectConfig {
  id: string;
  name: string;
  description: string;
  icon: any;
  color: string;
  sidebar: NavSection[];
}

export const PROJECTS: ProjectConfig[] = [
  {
    id: 'collector',
    name: 'Collector',
    description: 'Unified telemetry & logging SDK.',
    icon: Zap,
    color: '#ff6b00',
    sidebar: [
      {
        title: "Introduction",
        items: [
          { name: "Overview", path: "/collector", icon: BookOpen },
        ]
      },
      {
        title: "Installation",
        items: [
          { name: "Node.js SDK", path: "/collector/installation/nodejs", icon: Code2 },
          { name: "Spring Boot", path: "/collector/installation/springboot", icon: Cpu },
          { name: "Other Languages", path: "/collector/installation/other", icon: Terminal },
        ]
      },
      {
        title: "Guides",
        items: [
          { name: "Express Middleware", path: "/collector/guides/express", icon: Activity },
          { name: "Manual Logging", path: "/collector/guides/logging", icon: Terminal },
          { name: "SOC2 Compliance", path: "/collector/guides/security", icon: ShieldCheck },
        ]
      }
    ]
  },
  {
    id: 'guard',
    name: 'Cyxor Guard',
    description: 'Real-time threat detection & response.',
    icon: ShieldCheck,
    color: '#3b82f6',
    sidebar: [
      {
        title: "Introduction",
        items: [
          { name: "How Guard Works", path: "/guard", icon: ShieldCheck },
        ]
      },
      {
        title: "Setup",
        items: [
          { name: "VPC Integration", path: "/guard/setup/vpc", icon: Lock },
          { name: "Agent Install", path: "/guard/setup/agent", icon: Terminal },
        ]
      }
    ]
  },
  {
    id: 'auditor',
    name: 'AI Auditor',
    description: 'Automated compliance auditing.',
    icon: Eye,
    color: '#10b981',
    sidebar: [
      {
        title: "Introduction",
        items: [
          { name: "AI Compliance Engine", path: "/auditor", icon: Zap },
        ]
      },
      {
        title: "Reporting",
        items: [
          { name: "SOC2 Reports", path: "/auditor/reports/soc2", icon: ShieldCheck },
          { name: "HIPAA Audits", path: "/auditor/reports/hipaa", icon: Radiation },
        ]
      }
    ]
  }
];
